import service from './src/index';

export default {
    install(Vue) {
        Vue.prototype.$preLoading = service;
    },
    service
}